import script from "./BodorNextTube.vue?vue&type=script&setup=true&lang=js"
export * from "./BodorNextTube.vue?vue&type=script&setup=true&lang=js"

import "./BodorNextTube.vue?vue&type=style&index=0&id=76374dcd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76374dcd"]])

export default __exports__